import React from 'react'
import { useTranslation } from 'react-i18next'

import Alert from '@core/components/alert/alert'
import { Button } from '@core/components/button/button'

/**
 * Displays an alert to the user of an upcoming maintenance
 * @constructor
 */

const STORAGE_KEY = 'ftg_maintenance_1'
const EXPIRATION_DAYS = 5
const MAINTENANCE_DATE = new Date('2025-05-20T19:00:00.000-0500')

const maintenanceDatePretty = Intl.DateTimeFormat(undefined, {
  weekday: 'long',
  month: 'long',
  day: 'numeric',
  year: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
  timeZoneName: 'short',
}).format(MAINTENANCE_DATE)

export const MaintenanceWarning = () => {
  const { t } = useTranslation('legacy', { keyPrefix: 'maintenance' })
  const { t: tCommon } = useTranslation('common')
  const [dismissedUntilDate, setDismissedUntilDate] = React.useState(
    localStorage.getItem(STORAGE_KEY),
  )

  const isDismissed = dismissedUntilDate && new Date(dismissedUntilDate) > new Date()
  const isPastMaintenanceDate = MAINTENANCE_DATE < new Date()

  // Clear storage if warning should be rendered but a date is set
  if (!isDismissed && dismissedUntilDate) {
    localStorage.removeItem(STORAGE_KEY)
    setDismissedUntilDate(null)
  }

  if (isDismissed || isPastMaintenanceDate) {
    return null
  }

  return (
    <Alert
      severity="info"
      action={
        <Button
          label={t('dismiss_message')}
          color="inherit"
          size="small"
          aria-label={tCommon('accessibility.dismiss_maintenance_warning')}
          onClick={async () => {
            const expiryDate = new Date()
            expiryDate.setDate(expiryDate.getDate() + EXPIRATION_DAYS)
            setDismissedUntilDate(expiryDate.toISOString())
            localStorage.setItem(STORAGE_KEY, expiryDate.toISOString())
          }}
        />
      }
      sx={{ position: 'absolute', width: '100vw', zIndex: 1001 }}
      square
    >
      {t('offline_notice', { date: maintenanceDatePretty })}
    </Alert>
  )
}
